import React from 'react'
import {
  AccountBenefits,
  Activity,
  BillPayment,
  CheckCapture,
  Critical,
  Desktop,
  DirectDeposit,
  Flag,
  Help,
  Home,
  Merchant,
  Mgm,
  PackageSize,
  Phone,
  PhoneAlt,
  PPCashCard,
  Qrc,
  Rocket,
  ShippingPack,
  SwitchCard,
  Verified,
  Website,
  World,
} from '../../../icons'

const iconProps = {
  width: '24',
  height: '24',
  primaryColor: '#142C8E',
  secondaryColor: '#142C8E',
  thirdColor: '#142C8E',
  fourthColor: '#142C8E',
  fifthColor: '#142C8E',
  sixthColor: '#142C8E',
  seventhColor: '#142C8E',
  eighthColor: '#142C8E',
}

export const navbarRoutes = [
  {
    id: 1,
    title: 'Docs',
    children: [
      {
        title: 'Online',
        url: '/docs/online/',
      },
      {
        title: 'In-Person',
        url: '/docs/in-person/',
      },
      {
        title: 'Multiparty',
        url: '/docs/multiparty/',
      },
      {
        title: '3rd-Party',
        url: '/docs/3rd-party/',
      },
      {
        title: 'Payouts',
        url: '/docs/payouts/',
      },
      {
        title: 'Disputes',
        url: '/docs/disputes/',
      },
      {
        title: 'Reports',
        url: '/docs/reports/',
      },
      {
        title: 'Identity',
        url: '/docs/log-in-with-paypal/',
      },
      {
        title: 'Docs Archive',
        url: '/docs/archive',
      },
    ],
  },
  {
    id: 2,
    title: 'APIs & SDKs',
    children: [
      {
        title: 'REST APIs',
        url: '/api/rest/',
      },
      {
        title: 'JavaScript SDK',
        url: '/sdk/js/',
      },
      {
        title: 'NVP/SOAP APIs',
        url: '/api/nvp-soap/',
      },
      {
        title: 'Donate SDK',
        url: '/sdk/donate/',
      },
      {
        title: 'Braintree GraphQL API',
        url: 'https://graphql.braintreepayments.com/',
      },
    ],
  },
  {
    id: 3,
    title: 'Tools',
    children: [
      {
        title: 'Sandbox Testing Guide',
        url: '/tools/sandbox/',
      },
      {
        title: 'API Executor',
        url: 'https://www.paypal.com/apex/home',
      },
      {
        title: 'Demo Portal',
        url: 'https://demo.paypal.com/us/demo/home',
      },
      {
        title: 'Credit Card Generator',
        url: 'https://developer.paypal.com/developer/creditCardGenerator',
      },
      {
        title: 'API Status',
        url: 'https://www.paypal-status.com/api/production',
      },
    ],
  },
  {
    id: 4,
    title: 'Support',
    link: '/docs/support/',
  },
]
